import React from "react";
import { useParams } from "react-router-dom";
import { useAuthContext } from "../../../AuthContextWrapper";
import { Box, Button, Typography } from "@mui/material";
import { LARAVEL_APP_HOME, LARAVEL_APP_HOST } from "../../../constants";

import advisor1 from "../../assets/financial-advisor-man-1x.png";
import advisor15 from "../../assets/financial-advisor-man-1.5x.png";
import advisor2 from "../../assets/financial-advisor-man-2x.png";
import advisor3 from "../../assets/financial-advisor-man-3x.png";

import { FlowScreenWrapper } from "../shared/FlowScreenWrapper";

export const AlreadySubmittedScreen = (): JSX.Element => {
  const { flow } = useAuthContext()
  const { screenName } = useParams();
  const currentScreen = flow?.getCurrentFlowScreen(screenName);

  const handleComplete = async (): Promise<boolean> => {
    if (!currentScreen) throw Error("couldn't determine currentScreen");

    window.location.href = `${LARAVEL_APP_HOST}/home`;
    return true;
  };

  return currentScreen ? (
    <FlowScreenWrapper hideSectionHeading={true} centerContent={true}>
      <>
        <Box
          sx={{
            my: 2,
            textAlign: "center",
          }}
        >
          <img
            srcSet={`${advisor15} 1.5x, ${advisor2} 2x, ${advisor3} 3x`}
            src={advisor1}
            alt="Financial Advisor wearing glasses with his left hand on his right, ready to help."
            title="Financial Advisor Ready to Help"
          />
        </Box>
        <Box
          sx={{
            my: 2,
            textAlign: "center",
          }}
        >
          <Typography component="h2" variant="h3">
            Looks like you have already requested a conversation with a
            financial advisor.
          </Typography>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            my: "1.5rem",
          }}
        >
          <Button
            variant="contained"
            onClick={handleComplete}
            sx={{
              mb: "1rem",
            }}
          >
            Return to Home
          </Button>
        </Box>
      </>
    </FlowScreenWrapper>
  ) : (
    <></>
  );
};
